var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheckboxChecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:baseline-check-box",
    clipPath: "url(#clip0_11396_199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.2889 0.200195H1.71112C1.31035 0.200195 0.925995 0.359401 0.642606 0.642789C0.359218 0.926178 0.200012 1.31053 0.200012 1.71131V12.2891C0.200012 12.6899 0.359218 13.0742 0.642606 13.3576C0.925995 13.641 1.31035 13.8002 1.71112 13.8002H12.2889C12.6897 13.8002 13.074 13.641 13.3574 13.3576C13.6408 13.0742 13.8 12.6899 13.8 12.2891V1.71131C13.8 1.31053 13.6408 0.926178 13.3574 0.642789C13.074 0.359401 12.6897 0.200195 12.2889 0.200195ZM5.4889 10.778L1.71112 7.0002L2.77646 5.93486L5.4889 8.63975L11.2236 2.90508L12.2889 3.97797L5.4889 10.778Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11396_199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckboxChecked);
export default __webpack_public_path__ + "static/media/icon--checkbox-checked.dd74d3172746ac579d91d69689b453d3.svg";
export { ForwardRef as ReactComponent };